<div class="content">
    <h1 class="page-title">Filiação</h1>
    <h4>Filiação ao Departamento de Capacitação da CBT</h4>
    <p>
        Entendemos que é de fundamental importância que os profissionais filiados ao Depto. de Capacitação da CBT
        recebam benefícios importantes.
    </p>
    <h4>Veja alguns benefícios</h4>
    <ol>
        <li>Descontos em ingressos de eventos oficiais da CBT como Copa Davis, Fed Cup entre outros;</li>
        <li>Descontos substanciais nos cursos e workshops oficiais da CBT;</li>
        <li>Descontos nos cursos, workshops, conferências e congressos outorgados ou apoiados pela CBT;</li>
        <li>Ter o seu curriculum atualizado por cidade ou região no site da CBT (graduados);</li>
        <li>Carteira oficial da CBT;</li>
        <li>Diploma oficial da CBT constando a graduação profissional alcançada pelo filiado (sistema SNGP);</li>
        <li>Inserção no Sistema Nacional de Graduação Profissional (SNGP);</li>
        <li>Divulgação e indicação de ofertas de trabalho (sistema SNGP);</li>
    </ol>
    <p>
        Portanto, gostaríamos de incentivá-lo a fazer sua filiação ao Departamento de Capacitação e juntos trabalharmos
        para o desenvolvimento do tênis de nosso país.
    </p>
    <h4>Filiação:</h4>
    <p>
        O valor para a filiação ao Departamento de Capacitação da CBT é de:<br />
        - Á vista: R$ 200,00
    </p>
    <p><strong>Obs:</strong> Validade de 12 meses a contar da data de filiação.</p>
    <p>
        <strong>Filiação para jogador</strong>: Jogador filiado ao Departamento Técnico<br />
        - À vista: R$ 140,00
    </p>
    <h4>Forma de pagamento</h4>
    <p>
        O pagamento é através de depósito bancário no
        <strong>Banco Itaú</strong> <br /><br />

        agência: 0740; <br />c/c: 66927-0 <br />CNPJ: 08.679.865/0001-38 <br />em nome de: CESAR KIST E CD LTDA ME<br /><br />
        Após realizar o depósito, enviar um e-mail para capacitacao@cbtenis.com.br, aos cuidados do Departamento de
        Capacitação com o comprovante do depósito e os dados abaixo.
    </p>
    <p>
        <strong>Nome completo:</strong>
        _____________________________________________________________
    </p>
    <p><strong>CPF (obrigatório)</strong>: ____________________________________________________________</p>
    <p><strong>Endereço</strong>:_________________________________________<strong>Complemento</strong>:_____________</p>
    <p>
        <strong>Bairro</strong>:_____________<strong>CEP</strong>:_______________
        <strong>Cidade:</strong>_______________ <strong>Estado</strong>:________
    </p>
    <p>
        <strong>Atenção</strong>: É importante o preenchimento correto e completo destes dados para que enviemos a
        carteirinha de filiação.
    </p>
</div>
